import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { HelmetProvider } from "react-helmet-async";

// Pages
import Home from "@/pages/Home";
import LaVilla from "@/pages/LaVilla";
import Abbonamenti from "@/pages/Abbonamenti";
import Estate2027 from "@/pages/Estate2027";
import GiftCardSuccess from "@/pages/GiftCardSuccess";
import AbbonamentoSuccess from "@/pages/AbbonamentoSuccess";
import EventiPrivati from "@/pages/EventiPrivati";
import NightEvents from "@/pages/NightEvents";
import LavoraConNoi from "@/pages/LavoraConNoi";
import FoodDrink from "@/pages/FoodDrink";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import ShopSuccess from "@/pages/ShopSuccess";
import Contatti from "@/pages/Contatti";
import FAQ from "@/pages/FAQ";
import Privacy from "@/pages/Privacy";
import Cookie from "@/pages/Cookie";
import Termini from "@/pages/Termini";
import Regolamento from "@/pages/Regolamento";
import AdminDashboard from "@/pages/AdminDashboard";
import VirtualTour from "@/pages/VirtualTour";

// Components
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MobileCTA from "@/components/MobileCTA";
import CookieBanner from "@/components/CookieBanner";
import VisitorTracker from "@/components/VisitorTracker";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
  return (
    <HelmetProvider>
      <div className="App bg-ivory min-h-screen">
        <BrowserRouter>
          <Routes>
            {/* Admin route without header/footer */}
            <Route path="/admin" element={<AdminDashboard />} />
            {/* Virtual Tour - full immersive, no header/footer */}
            <Route path="/virtual-tour" element={<VirtualTour />} />
            
            {/* Public routes with header/footer */}
            <Route path="*" element={
              <>
                <ScrollToTop />
                <VisitorTracker />
                <Header />
                <main>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/la-villa" element={<LaVilla />} />
                    <Route path="/abbonamenti" element={<Abbonamenti />} />
                    <Route path="/estate-2027" element={<Estate2027 />} />
                    <Route path="/giftcard/success" element={<GiftCardSuccess />} />
                    <Route path="/abbonamenti/success" element={<AbbonamentoSuccess />} />
                    <Route path="/eventi-privati" element={<EventiPrivati />} />
                    <Route path="/night-events" element={<NightEvents />} />
                    <Route path="/lavora-con-noi" element={<LavoraConNoi />} />
                    <Route path="/food-drink" element={<FoodDrink />} />
                    <Route path="/shop" element={<Shop />} />
                    <Route path="/shop/:productId" element={<ProductDetail />} />
                    <Route path="/shop/success" element={<ShopSuccess type="shop" />} />
                    <Route path="/contatti" element={<Contatti />} />
                    <Route path="/faq" element={<FAQ />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/cookie" element={<Cookie />} />
                    <Route path="/termini" element={<Termini />} />
                    <Route path="/regolamento" element={<Regolamento />} />
                  </Routes>
                </main>
                <Footer />
                <MobileCTA />
                <CookieBanner />
              </>
            } />
          </Routes>
          <Toaster position="top-right" />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
